import { jsx as _jsx } from "react/jsx-runtime";
import { JobList } from '../../components/job_list';
export const IRBView = () => {
    return (_jsx("div", { children: _jsx(JobList, {}) }));
};
